import { memo, useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ReactTooltip from "../../Components/ReactTooltip/ReactTooltip";
import { useAppDispatch, useAppSelector } from "../../ReduxTool/store/hooks";
import { CollapseIcon, IconLeadBoard, ShopingIcon } from "../../assests/icons/Icons";
import React from "react";

export const sideHeader = [
  { path: "/Consumer", headerName: "Consumer", Icon: <IconLeadBoard  className="size-5"/>, title: "Project Dashboard", tooltipid: "prject_dashboard", tabname: "Project Dashboard" },
  { path: "/Consumer/order_status", headerName: "Status head", Icon: <ShopingIcon />, title: "Order Status", tooltipid: "order_list", tabname: "Request Orders" },
];

const DefaultAside = () => {
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector((state) => state.auth.user);
  const [showModal, setShowModal] = useState(false);
  const [uname, setUname] = useState({ fname: "", lname: "" });
  const location = useLocation();
  const [isCollapse, setIsCollapse] = useState(true);

  const handleSideBar = () => setIsCollapse((prev) => !prev);
  const Navigate = useNavigate();

  const logout = async (e : { preventDefault: () => void }) => {
    e.preventDefault();
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.clear();
    Navigate("/");
    return false;
  };

  useEffect(() => {
    if (!userInfo.emailid) {
      let user = localStorage.getItem("user");
      if (user) {
        let info = JSON.parse(user);
      }
    }
    if (userInfo?.fname) {
      setUname({ fname: userInfo.fname.split("")[0], lname: userInfo.lname!.split("")[0] });
    }
  }, [userInfo]);

  const handlePathChange = (item : any) => {
    Navigate(item.path);
    if (item.tabname) sessionStorage.setItem("activeTab", item.tabname);
  };

  return (
    <>
      <div className={`px-1 pb-1 flex flex-col justify-between h-full transition-all ease-in-out duration-500 ${isCollapse ? "w-[16.5rem]" : "w-[56px]"}`}>
        <div className={`w-full`}>
          <div className="flex flex-col items-center w-full">
            <ul className={`grow w-full h-full flex flex-col justify-start items-start gap-2 mt-2 py-2 max-h-[80vh] overflow-y-auto custom-scrollbar-css overflow-x-hidden transition-all duration-500`}>
              {sideHeader.map((item, i) => (
                <React.Fragment key={i}>
                  {/* <li data-tooltip-id={`${item.tooltipid}_tooltip`} className="w-full"> */}
                  <li data-tooltip-id={`${item.tooltipid}`} className="w-full">
                    <button onClick={() => handlePathChange(item)} className={`cursor-pointer hover:bg-gray-200 ${item.path === location.pathname ? "bg-gray-200" : ""} ${isCollapse ? "w-[98%]" : "w-[46px]"} p-3 rounded-md flex items-center gap-x-2 overflow-hidden transition-all duration-500`}>
                      <div className="flex-shrink-0">{item.Icon}</div>
                      <div className={`whitespace-nowrap transition-all duration-500 ${isCollapse ? "max-w-xs opacity-100 pl-1" : "max-w-0 opacity-0"}`}>{item.title}</div>
                    </button>
                  </li>
                  {!isCollapse && <ReactTooltip place="right" id={`${item.tooltipid}_tooltip`} content={item.title} Side={"RSB"} />}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
        <div className="w-full">
          <button type="button" onClick={handleSideBar} className={`cursor-pointer border w-full p-3 hover:bg-gray-200 rounded-md flex items-center gap-x-2 overflow-hidden transition-all duration-300 ease-in-out`}>
            <div className="flex-shrink-0">{<CollapseIcon className={`size-7 transition-transform duration-100 ${!isCollapse ? "-rotate-90" : "rotate-90"}`} />}</div>
            <div className={`whitespace-nowrap transition-all duration-500 ease-in-out ${!isCollapse ? "max-w-0 opacity-0" : "max-w-xs opacity-100 "}`}>Collapse Sidebar</div>
          </button>
        </div>
      </div>
    </>
  );
};

export default memo(DefaultAside);